import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

export function LegalLinks({ testId, className }: { testId: string; className?: string }) {
  const { t } = useTranslation();
  return (
    <div
      data-testid={testId}
      className={cn("flex flex-wrap items-center gap-x-2 gap-y-1", className)}
    >
      <Link to="/privacy" className="hover:text-foreground hover:underline underline-offset-2">
        {t("legal.linkPrivacy")}
      </Link>
      <span aria-hidden="true">·</span>
      <Link to="/terms" className="hover:text-foreground hover:underline underline-offset-2">
        {t("legal.linkTerms")}
      </Link>
    </div>
  );
}

/** Notice under sign-in / set-password / magic-link actions. */
export function LegalContinueNotice({ className }: { className?: string }) {
  return (
    <p
      data-testid="legal-continue-notice"
      className={cn("text-[11px] leading-snug text-muted-foreground", className)}
    >
      <Trans
        i18nKey="legal.continueNotice"
        components={[
          <Link
            key="terms"
            to="/terms"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-2 hover:text-foreground"
          />,
          <Link
            key="privacy"
            to="/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-2 hover:text-foreground"
          />,
        ]}
      />
    </p>
  );
}
